import React from 'react';
import './style.scss';
import PropTypes from 'prop-types';

const Arrow = ({ direction, onClick }) => (
    <div className={`slider-arrow-wrapper ${direction} active`} rel="nofollow" onClick={onClick}>
        <span className="arrow"></span>
    </div>
);

Arrow.propTypes = {
    direction: PropTypes.string
};

export default Arrow;



// WEBPACK FOOTER //
// ./src/shared/media/slider/arrow/index.js